import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

// Rendimento do Caixa (Simple Earn) — Fase 1b leitura. Consome o REST /earn/overview do backend:
// produtos flexible/locked (APR/liquidez/lock) + posição atual (quanto rende + juros). Earn é
// mainnet-only → o backend força produção; em ambiente sem chave de prod válida vem available:false.
const EARN_URL = getBaseUrl('/earn/');

export async function getEarnOverview(asset = 'USDT') {
    const params = new URLSearchParams();
    if (asset) params.set('asset', asset);
    return await appRequest.doGetRequest(`${EARN_URL}overview?${params.toString()}`);
}

// Fase 2 — escrita FLEXÍVEL (manual-confirm; o componente confirma antes de chamar).
export async function subscribeEarnFlexible(productId, amount, asset = 'USDT') {
    return await appRequest.doPostRequest(`${EARN_URL}subscribe`, { productId, amount, asset });
}

export async function redeemEarnFlexible(productId, amount, redeemAll = false) {
    return await appRequest.doPostRequest(`${EARN_URL}redeem`, { productId, amount, redeemAll });
}

// Fase 3 — auto-keeper (opt-in OFF): estado + preview do que faria agora; e liga/desliga + colchão.
export async function getEarnAutoConfig() {
    return await appRequest.doGetRequest(`${EARN_URL}auto-config`);
}

export async function setEarnAutoConfig(config) {
    return await appRequest.doPostRequest(`${EARN_URL}auto-config`, config);
}
